import React from "react";
import Dashboard from "./Dashboard";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GroupAdminSidebar from "../../../../Layout/GroupAdminSidebar";
import Scope3Layout from "../../../../Layout/Scope3Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
const WasteGeneratedDashboard = () => {
  const{user}=useUser();
  return (
    <MainDashboardLayout sidebar={user?.groupManager?<GroupAdminSidebar/>:<Scope3Layout />}>
      <Unauthorized requiredModule="Environment | Scope 3 | Waste generated">
        <Dashboard />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default WasteGeneratedDashboard;
